<template>
    <div class="section section-profile">
        <!-- Name - Profession -->
        <div class="name-profession">
             <!-- Name -->
            <div class="title-lines" ref="name">
                <h1 class="title">SEBASTIAN <br>BAEZ</h1>
                <div class="lines">
                    <span></span>
                    <span></span>
                </div>
            </div>
            <!-- Description -->
            <h3 class="description" ref="profession">Desarrollador Web / <br>Análista</h3>
        </div>
        <div class="moon"> 
            <div class="container-img-moon" ref="moon" >
                <!-- Moon -->
                <div class="img-moon" ref="moon_img">
                    <img src="@/assets/images/home/moon/moon.svg" data-depth="0.2" alt="moon">
                </div>
                <!-- Title -->
                <div class="cloud portfolio-title" ref="title_portfolio" data-depth="0.3">
                    <h1>Portafolio</h1>
                </div>
                <!-- CLOUDS -->
                <div class="cloud cloud-middle-right" ref="cloud_mr" data-depth="0.6">
                    <img src="@/assets/images/home/moon/cloud-middle-right.svg" alt="cloud">
                </div>
                <div class="cloud cloud-top-left" ref="cloud_tf" data-depth="0.3">
                    <img src="@/assets/images/home/moon/cloud-top-left.svg" alt="cloud">
                </div>
                <div class="cloud cloud-bottom-right" ref="cloud_br" data-depth="0.4">
                    <img src="@/assets/images/home/moon/cloud-bottom-right.svg" alt="cloud">
                </div>
                <div class="cloud cloud-bottom-left" ref="cloud_bl" data-depth="0.6">
                    <img src="@/assets/images/home/moon/cloud-bottom-left.svg" alt="cloud">
                </div>
                <div class="cloud cloud-top-right" ref="cloud_tr" data-depth="0.3">
                    <img src="@/assets/images/home/moon/cloud-top-right.svg" alt="cloud">
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import Parallax from 'parallax-js'
import {TweenMax, Power2, TimelineLite} from "gsap/TweenMax";
import ScrollToPlugin from "gsap/ScrollToPlugin";

export default {
    props: ['render', 'leave'],
    data() {
        return {
            top_clouds: []
        }
    },
    mounted() {
        let parallax_moon = new Parallax(this.$refs.moon);
        this.top_clouds = [this.$refs.cloud_tf, this.$refs.cloud_tr];
        this.onRenderAnimations();
    },
    methods: {
        onRenderAnimations() {
            // Name - Profession
            TweenLite.from(this.$refs.name, 1,
                { css: { right: '50%', opacity: 0 } },
                { css: { right: '0px', opacity: 1 } }
            );
            TweenLite.from(this.$refs.profession, 0.8,
                { css: { right: '50%', opacity: 0 } },
                { css: { right: '0px', opacity: 1 } }
            ).delay(0.3);
            // Title portfolio
            TweenLite.from(this.$refs.title_portfolio, 0.7, 
                { css: { left: '50%', opacity: 0 } },
                { css: { left: '0px', opacity: 1 } },
            );
            // Moon
            TweenLite.from(this.$refs.moon_img, 0.8, 
                { css: { left: '50%', opacity: 0 }  },
                { css: { left: '0px', opacity: 1 } },
            );
            // Cloud Middle Right
            TweenLite.from(this.$refs.cloud_mr, 0.3, 
                { css: { left: '50%', opacity: 0 }  },
                { css: { left: '0px', opacity: 1 } },
            ).delay(0.6);
            // Top Clouds
            TweenLite.from(this.top_clouds, 0.8, 
                { css: { left: '50%', opacity: 0 }  },
                { css: { left: '0px', opacity: 1 } },
            ).delay(0.4);
            // Cloud Bottom Right
            TweenLite.from(this.$refs.cloud_br, 0.9, 
                { css: { left: '50%', opacity: 0 }  },
                { css: { left: '0px', opacity: 1 } },
            ).delay(0.4);
            // Cloud Bottom Left
            TweenLite.from(this.$refs.cloud_bl, 0.7, 
                { css: { left: '50%', opacity: 0 }  },
                { css: { left: '0px', opacity: 1 } },
            ).delay(0.6);
        },
        leaveAnimations() {
            let app = this;

            // Name - Profession
            TweenLite.to(this.$refs.name, 0.6,
                { css: { right: '20%', opacity: 0  } },
            );
            TweenLite.to(this.$refs.profession, 0.4,
                { css: { right: '20%', opacity: 0  } },
            ).delay(0.3);
            // Title Portfolio
            TweenLite.to(this.$refs.title_portfolio, 0.8, 
                { css: { left: '70%', opacity: 0 } },
            ).delay(0.2);
            // Moon
            TweenLite.to(this.$refs.moon_img, 0.7, 
                { css: { left: '70%', opacity: 0 } }
            ).delay(0.3);
            // Cloud Middle Right
            TweenLite.to(this.$refs.cloud_mr, 0.6, 
                { css: { left: '70%', opacity: 0 } }
            ).delay(0.3);
            // Top Clouds
            TweenLite.to(this.top_clouds, 0.6, 
                { css: { left: '70%', opacity: 0 } }
            );
            // Cloud Bottom Right
            TweenLite.to(this.$refs.cloud_br, 0.6, 
                { css: { left: '50%', opacity: 0 } }
            );
            // Cloud Bottom Left
            TweenLite.to(this.$refs.cloud_bl, 0.7, 
                { css: { left: '50%', opacity: 0 } }
            );
        },
        returnAnimations() {
            // Name - Profession
            TweenLite.fromTo(this.$refs.name, 1,
                { css: { right: '20%', opacity: 0 } },
                { css: { right: '0px', opacity: 1 } }
            );
            TweenLite.fromTo(this.$refs.profession, 0.8,
                { css: { right: '20%', opacity: 0 } },
                { css: { right: '0px', opacity: 1 } }
            ).delay(0.3);
            // Title portfolio
            TweenLite.fromTo(this.$refs.title_portfolio, 0.8, 
                { css: { left: '70%', opacity: 0 } },
                { css: { left: '0px', opacity: 1 } },
            ).delay(0.2);
            // Moon
            TweenLite.fromTo(this.$refs.moon_img, 1, 
                { css: { left: '70%', opacity: 0 }  },
                { css: { left: '0px', opacity: 1 } },
            );
            // Cloud Middle Right
            TweenLite.fromTo(this.$refs.cloud_mr, 0.3, 
                { css: { left: '70%', opacity: 0 }  },
                { css: { left: '0px', opacity: 1 } },
            ).delay(0.6);
            // Top Clouds
            TweenLite.fromTo(this.top_clouds, 0.8, 
                { css: { left: '70%', opacity: 0 }  },
                { css: { left: '0px', opacity: 1 } },
            ).delay(0.4);
            // Cloud Bottom Right
            TweenLite.fromTo(this.$refs.cloud_br, 0.9, 
                { css: { left: '50%', opacity: 0 }  },
                { css: { left: '0px', opacity: 1 } },
            ).delay(0.4);
            // Cloud Bottom Left
            TweenLite.fromTo(this.$refs.cloud_bl, 0.7, 
                { css: { left: '50%', opacity: 0 }  },
                { css: { left: '0px', opacity: 1 } },
            ).delay(0.6);
        }
    },
    watch: {
        render() {
            this.returnAnimations();                
        },
        leave() {
            this.leaveAnimations();
        }
    }
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/_variables.scss';
@import '@/assets/css/_mixins.scss';

.section-profile {
    position: relative;
    display: flex;
    flex-direction: column-reverse;
    overflow: hidden;

    // Moond and clouds
    .moon {
        z-index: 1;
        position: absolute;
        width: 165vw;
        height: 165vw;
        left: -35%;
        top: -7rem;
        margin: auto;
        display: flex;
        align-items: center;
        justify-content: center;

        .container-img-moon {
            position: relative;
            width: 40%;
            height: 40%;

            .cloud { 
                position: absolute; 
                z-index: 2; 
                width: 100%; 
                height: 100%;
                img { position: absolute }
            }

            .img-moon {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;

                img { 
                    width: 100%;
                    vertical-align: middle;
                }
            }

            .portfolio-title {
                font-family: $Roboto-Bold;
                text-shadow: 0 10px 15px rgba(2, 11, 22, 0.2);
                font-family: 1.2rem;
                color: $main-red-1;
                position: relative;
                display: flex !important;
                align-items: center;
                z-index: 3;
                        
                h1 {
                    position: absolute !important;
                    left: -15%
                }

                @media (min-width: 1024px) {
                    font-size: 230%
                }
            }

            .cloud-middle-right {
                top: 0;
                left: 0;
                img { width: 88%; top: 20%; right: -50% }
            }

            .cloud-top-left {
                top: 0;
                left: 0;
                img { width: 87%; top: -5%; left: -35% }
            }

            .cloud-bottom-right {
                right: 0;
                top: 0;
                img { width: 87%; bottom: -18%; right: -28%; }
            }

            .cloud-bottom-left {
                left: 0;
                bottom: 0;
                img { width: 87%; bottom: 0; left: -49%; bottom: -5% }
            }
            .cloud-top-right {
                top: 0;
                right: 0;
                img { width: 70%; top: -22%; right: -7% }
            }
        }

        @media (min-width: 760px) {
            width: 100vw;
            height: 100vw;
            top: 0;
            bottom: 0;
            left: 23%;
        }

        @media (min-width: 1024px) {
            width: 1350px !important;
            height: 1350px !important;
            left: 30%
        }
    }

    // Name profession
    .title-lines, .description, h1 {
        z-index: 2;
    }

    @media (max-width: 500px) {
        .title-lines .title {
            font-size: 50px
        }
        .description {
            font-size: 15px !important
        }
        .cloud:not(.portfolio-title) {
            opacity: 0.4 !important;
            text-shadow: revert
        }
    }

    .name-profession {
        @extend %default-title;
    }
}
</style>